import { StoreModule } from '@ngrx/store';

import { provideCompanyData } from '@vlaio/shared/company';
import { createDataProviderFromModule } from '@vlaio/shared/core';

import { reducers } from './application.store';
import { SelfRegistrationStoreSlice } from './interfaces';
import { ApplicationApiService, ApplicationService } from './services';

export const provideSelfRegistrationApplicationData = createDataProviderFromModule({
	imports: [StoreModule.forFeature(SelfRegistrationStoreSlice.Application, reducers)],
	providers: [ApplicationService, ApplicationApiService, provideCompanyData()]
});
